import { render, staticRenderFns } from "./BetSlipEditor.vue?vue&type=template&id=078c59f3&scoped=true&"
import script from "./BetSlipEditor.vue?vue&type=script&lang=js&"
export * from "./BetSlipEditor.vue?vue&type=script&lang=js&"
import style0 from "./BetSlipEditor.vue?vue&type=style&index=0&id=078c59f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078c59f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VIcon,VSwitch,VTextField})
